var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76112 11.7167L2.01193 13.9642C1.68623 14.9413 1.52338 15.4299 1.63923 15.7547C1.74005 16.0375 1.96254 16.2599 2.24526 16.3608C2.57014 16.4766 3.05869 16.3138 4.03579 15.9881L6.28335 15.2389C6.55062 15.1498 6.68426 15.1052 6.80905 15.0433C6.91987 14.9883 7.02534 14.9231 7.12412 14.8486C7.23534 14.7647 7.33495 14.6651 7.53416 14.4658L15 7C15.5452 6.45475 15.8179 6.18213 15.9636 5.88803C16.2409 5.32848 16.2409 4.67152 15.9636 4.11197C15.8179 3.81787 15.5452 3.54525 15 3C14.4548 2.45475 14.1821 2.18213 13.888 2.03639C13.3285 1.75911 12.6715 1.75911 12.112 2.03639C11.8179 2.18212 11.5453 2.45475 11 2.99999L11 3L3.53416 10.4658L3.53416 10.4658C3.33494 10.6651 3.23534 10.7647 3.15143 10.8759C3.07692 10.9747 3.01173 11.0801 2.95671 11.191C2.89475 11.3157 2.85021 11.4494 2.76112 11.7167Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4L14 8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.917a0fcd8d51dafe356fec223f9c753c.svg";
export { ForwardRef as ReactComponent };